module.exports = __webpack_public_path__ + "img/4.693727fa.jpg";